import React, { Component } from 'react'
import { connect } from 'react-redux'
import { itemsFetchComments, updateExistingComment, addNewResponse, itemsFetchResponses, deleteExistingResponse } from '../actions/index'
import { addNewComment } from '../actions/index'
// import { changeCommentScore } from '../actions/index'
//import { updateExistingComment } from '../actions/index'
import { deleteExistingComment } from '../actions/index'
import Modal from 'react-modal'
import CloseIcon from '../images/close.svg'
import Trash from '../images/trash-simple.svg'
import Edit from '../images/edit.svg'
import Respond from '../images/reply.svg'

class Comments extends Component {

      state = {
        commentModalOpen: false,
        commentInput: "",
        inCommentEditMode: false,
        editCommentId: 0,
        responseModalOpen: false,
        responseInput: '',
        commentIDForResponse: '',
        originalCommentAuthorEmail: '',
        image: ""
      }
    
      /* had to add setTimeout as this.props.activePost.id wasn't ready when page accessed by back button */
      componentDidMount() {

        setTimeout(function() {
          this.props.fetchComments(this.props.activePostId);
          this.props.fetchResponses(this.props.activePostId);
        }.bind(this), 5)

        // check if a Facebook user with an image and if so add that to state
        if (this.props.currentUser.image) {
          this.setState({image: this.props.currentUser.image})
        }
      }

      componentWillMount() {
        Modal.setAppElement('body');
      }
    
      openCommentModal = () => {
        this.setState(() => ({
          commentModalOpen: true
        })
        )
      }
    
      closeCommentModal = () => {
        this.setState(() => ({
          commentModalOpen: false,
          commentInput: ""
        })
        )
      }
    
      enterCommentEdit = (commentId, commentBody) => {
        this.setState(() => ({
          inCommentEditMode: true,
          commentModalOpen: true,
          commentInput: commentBody,
          editCommentId: commentId
        })
        )
      }

      enterResponseEdit = (commentID, originalCommentAuthorEmail) => {
        this.setState(() => ({
          responseModalOpen: true,
          commentIDForResponse: commentID,
          originalCommentAuthorEmail: originalCommentAuthorEmail
        })
        )
      }

      exitResponseEdit = () => {
        this.setState(() => ({
          responseModalOpen: false
        })
        )
      }
    
      commentInput = (event) => {
        this.setState({commentInput: event.target.value})
      }
    
      commentSubmit = (event) => {

        if (this.state.inCommentEditMode === false) {
          this.props.addComment(this.state.commentInput, this.props.currentUser.user_metadata.full_name, this.props.currentUser.email, this.props.activePostId, this.state.image)
          event.preventDefault();
          this.closeCommentModal();
        } else {
          this.props.updateComment(this.state.editCommentId, this.state.commentInput,this.props.currentUser.user_metadata.full_name, this.props.currentUser.email, this.props.activePostId);
          event.preventDefault();
          this.closeCommentModal();
        }
      }

      responseInput = (event) => {
        this.setState({responseInput: event.target.value})
      }

      responseSubmit = (event) => {
        this.props.addResponse(this.state.commentIDForResponse, this.props.activePostId, this.state.responseInput, this.props.currentUser.user_metadata.full_name, this.props.currentUser.email, this.state.originalCommentAuthorEmail);
        event.preventDefault();
        this.exitResponseEdit();
      }

    
      render() {
    
    
        return (
    
          <div className="comments">
            
            <button style={{display: 'block', margin: 'auto', marginBottom: 50, marginTop: 40}} className="purple-button" onClick={ () => this.openCommentModal() }>Add new comment</button>
            { this.props.activeComments.map( (comment) => (
              <div key={comment._id}>
                <div className="comment">
                  <p style={{textAlign: 'center', marginBottom: 0}}>{comment.body}</p>
                  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>

                    <img alt="" src={comment.gravatar} style={{borderRadius: 50, maxHeight: '25px', marginRight: 10}} />

                    <h4 style={{textAlign: 'center'}}>Posted by {comment.authorName} on {comment.date}</h4>
                  </div>

                  { // edit controls should be seen by author of comment and admin

                    (comment.authorEmail === this.props.currentUser.email || this.props.currentUser.email === 'nathangaw@garneteducation.com') 

                    ?

                      <div className="comment-edit-buttons" style={{display: 'flex', justifyContent: 'flex-end'}}>


                        { // only admin should be able to respond to comments

                          (this.props.currentUser.email === 'nathangaw@garneteducation.com')

                          ?

                          <img alt="Respond to comment" src={Respond} className="edit-icons" style={{width: 20, height: 20, marginRight: 20, marginBottom: 20}} onClick={ () => this.enterResponseEdit(comment._id, comment.authorEmail)}></img>

                          :

                          null

                        }

                        <img alt="Edit comment" src={Edit} className="edit-icons" style={{width: 20, height: 20, marginRight: 20, marginBottom: 20}} onClick={ () => this.enterCommentEdit(comment._id, comment.body)}></img>

                        <img alt="Delete comment" src={Trash} className="edit-icons" style={{width: 20, height: 20, marginRight: 20, marginBottom: 20}} onClick={ () => { if (window.confirm('Are you sure you want to delete this comment?'))this.props.deleteComment(comment._id)}}></img>

                      </div>
                    

                      

                    :

                    <div></div>

                  }
                  
                </div>
                <div>

                  {this.props.responses.filter( response => response.commentID === comment._id).map( (response) => (
                    <div className="response">

                        <p style={{textAlign: 'center', marginBottom: 0}}>{response.body}</p>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                          <img alt="" src={response.gravatar} style={{borderRadius: 50, maxHeight: '50px', marginRight: 10}} />
                          <h4 style={{textAlign: 'center'}}>Posted by {response.authorName} on {response.date}</h4>
                        </div>

                        { 

                          (comment.authorEmail === this.props.currentUser.email) 

                          ?

                            <div className="comment-edit-buttons" style={{display: 'flex', justifyContent: 'flex-end'}}>

                              <img alt="Delete" src={Trash} className="edit-icons" style={{width: 20, height: 20, marginRight: 20, marginBottom: 20}} onClick={ () => { if (window.confirm('Are you sure you want to delete this comment?'))this.props.deleteResponse(response._id)}}></img>

                            </div>
                          

                            

                          :

                          <div></div>

                        }











                    </div>

                  ))}

                </div>
              </div>

                

            

            ) ) }
    
    
            <Modal
              isOpen={this.state.commentModalOpen}
              contentLabel="Modal"
            >
              <img alt="" src={CloseIcon} style={{float: 'right', width: 40}} onClick={ () => this.closeCommentModal() } />
                
                <div>
                  <h1 style={{textAlign: 'center'}}>Add a comment</h1>
                  <form style={{textAlign: 'center'}} onSubmit={this.commentSubmit}>
                    <label>
                        Your comment <br/>
                        <textarea required rows="10" placeholder="Your comment" value={this.state.commentInput} onChange={this.commentInput}></textarea>
                    </label>
                    <input className="purple-button" style={{marginTop: 20}} type="submit" value="Submit" />
                   </form>
                </div>
    
              
            </Modal>

            <Modal
              isOpen={this.state.responseModalOpen}
              contentLabel="Modal"
            >
              <img alt="" src={CloseIcon} style={{float: 'right', width: 40}} onClick={ () => this.exitResponseEdit() } />
                
                <div>
                  <h1 style={{textAlign: 'center'}}>Add a response</h1>
                  <form style={{textAlign: 'center'}} onSubmit={this.responseSubmit}>
                    <label>
                        Your comment <br/>
                        <textarea required rows="10" placeholder="Your comment" value={this.state.responseInput} onChange={this.responseInput}></textarea>
                    </label>
                    <input className="purple-button" style={{marginTop: 20}} type="submit" value="Submit" />
                   </form>
                </div>
    
              
            </Modal>
    
          </div>
    
        )
      }
    
    }
    
    const mapStateToProps = (state) => {
      return {
        // need url to populate page if refreshed or accessed directly
        activePostId: state.router.location.pathname.substring(state.router.location.pathname.lastIndexOf('/')+1),
        activeComments: state.activeComments,
        activePost: state.activePost,
        currentUser: state.user,
        responses: state.responses   
      };
    };
    
    const mapDispatchToProps = (dispatch) => {
      return {
        fetchComments: (id) => dispatch(itemsFetchComments(id)),
        // changeCommentScore: (direction, id) => dispatch(changeCommentScore(direction, id)),
        addComment: (body, authorName, authorEmail, parentId, image) => dispatch(addNewComment(body, authorName, authorEmail, parentId, image)),
        // updateComment: (commentId, body) => dispatch(updateExistingComment(commentId, body)),
        deleteComment: (commentId) => dispatch(deleteExistingComment(commentId)),
        updateComment: (commentId, commentBody) => dispatch(updateExistingComment(commentId, commentBody)),
        addResponse: (commentID, postID, body, authorName, authorEmail, originalCommentAuthorEmail) => dispatch(addNewResponse(commentID, postID, body, authorName, authorEmail, originalCommentAuthorEmail)),
        fetchResponses: (id) => dispatch(itemsFetchResponses(id)),
        deleteResponse: (responseID) => dispatch(deleteExistingResponse(responseID))
      };
    };
    
    export default connect(mapStateToProps, mapDispatchToProps)(Comments);


// WEBPACK FOOTER //
// ./src/components/Comments.js